import { createContext } from 'react';
import { pagePrefix } from '../Constants/Analytics.js';

export const AnalyticsPageContext = createContext(pagePrefix);
